module.exports = {
  en: {
    'HRES96UC1': {
      '0': '[HRESZ6U] Approval Shift Change',
      '10': '[HRESZ6U] Approval Shift Change',
      '20': 'Order',
      '30': 'Emp. ID.',
      '40': 'Name',
      '50': 'Date Input',
      '60': 'Order',
      '70': 'Chang Date',
      '80': 'Shift Code',
      '90': 'Old',
      '99': 'Shift Change Request',
      '100': 'New',
      '110': 'Chang With',
      '120': 'Reason of Change',
      '130': 'Status',
      '140': 'Code Appr.',
      '150': 'Appr. Date',
      '160': 'Remark',
      '170': 'Next Step Approval'
    },
    'HRES96UC2': {
      '0': 'Detail of Approved',
      '10': 'For Employee',
      '20': 'Seq. App.',
      '30': 'Approved By',
      '40': 'Approved Date',
      '50': 'Current Status',
      '60': 'Status',
      '70': 'Approved',
      '80': 'Refused',
      '90': 'Remark',
      '100': 'No.of  selected',
      '110': 'Record'
    },
    'HRES96UC3': {
      '10': 'Shift Change Req. Detail',
      '20': 'For Employee',
      '30': 'Request Date',
      '40': 'Chang Date',
      '50': 'Request to change with',
      '60': 'Reason of Change',
      '70': 'Remark',
      '80': 'Req. Emp.',
      '90': 'Change With',
      '100': 'Old',
      '110': 'Old',
      '120': 'New',
      '130': 'New'
    }
  },
  th: {
    'HRES96UC1': {
      '0': '[HRESZ6U]  อนุมัติคำร้องขอแลกกะ',
      '10': '[HRESZ6U]  อนุมัติคำร้องขอแลกกะ',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ-นามสกุล',
      '50': 'วันที่บันทึกขอ',
      '60': 'ลำดับที่',
      '70': 'วันที่ขอแลก',
      '80': 'รหัสกะ',
      '90': 'เดิม',
      '99': 'คำร้องขอแลกกะ',
      '100': 'ใหม่',
      '110': 'แลกกับพนักงาน',
      '120': 'สาเหตุการขอแลกกะ',
      '130': 'สถานะ',
      '140': 'ผู้อนุมัติ',
      '150': 'วันที่อนุมัติ',
      '160': 'หมายเหตุการอนุมัติ',
      '170': 'ผู้อนุมัติลำดับถัดไป'
    },
    'HRES96UC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'สำหรับพนักงาน',
      '20': 'ลำดับที่อนุมัติ',
      '30': 'รหัสผู้อนุมัติ',
      '40': 'วันที่อนุมัติ',
      '50': 'สถานะปัจจุบัน',
      '60': 'สถานะ',
      '70': 'อนุมัติ',
      '80': 'ไม่อนุมัติ',
      '90': 'หมายเหตุ',
      '100': 'รายการที่เลือกทั้งหมด',
      '110': 'รายการ'
    },
    'HRES96UC3': {
      '10': 'รายละเอียดใบแลกกะ',
      '20': 'สำหรับพนักงาน',
      '30': 'วันที่บันทึกขอ',
      '40': 'วันที่ขอแลก',
      '50': 'ขอแลกกะกับ',
      '60': 'สาเหตุการขอแลกกะ',
      '70': 'หมายเหตุ',
      '80': 'ผู้ขอแลกกะ :',
      '90': 'ผู้ให้แลกกะ :',
      '100': 'เดิม',
      '110': 'เดิม',
      '120': 'ใหม่',
      '130': 'ใหม่'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres96u.js